import { AppDate } from '../envTypes';

import { Profile, StoreType } from './profile';
import { PopStoreExtendedSubscriptionLevel } from './creator-subscription';
import {
  ModelBase,
  OpenBoxMode,
  ShippingMode,
  ShowCustomization,
} from './base';
import { UpcomingShow } from './upcoming-show';
import { LiveStream } from './livestream';

export enum DayOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}

export interface TimeOfWeek {
  dayOfWeek: DayOfWeek;
  hour: number;
  minute: number;
  second: number;
}

export interface TippingAmount {
  amount: number;
  currency: 'USD';
}

export interface PopStoreCreatorTippingSettings {
  enabled?: boolean;
  minimumAmount?: number;
  defaultTippingButtonTitle?: string;
  tippingAmounts?: Array<TippingAmount>;
  requireContactInfo?: boolean;
}

export enum CollectionLayoutType {
  Racks = 'racks',
  Stacks = 'stacks',
}

export interface SocialAccount {
  instagramUrl?: string;
  youtubeUrl?: string;
  depopUrl?: string;
  ebayUrl?: string;
  facebookUrl?: string;
  tiktokUrl?: string;
  etsyUrl?: string;
  discordUrl?: string;
  lemon8Url?: string;
  snapchatUrl?: string;
  twitterUrl?: string;
  patreonUrl?: string;
  linkInBioUrl?: string;
}

export interface StoreFront {
  name: string;
  passcode: string;
  sellerPasscode?: string;
  sellerCode?: string;
  profile: Profile;
  createdAt: AppDate;
  storeType?: StoreType;
  tags?: string[];
  shippingFee?: number;
  adjustedPopshopShippingFee?: number;
  bio?: string;
  announcement?: string;
  salesTaxRate?: { [key: string]: number };
  openBoxMode?: OpenBoxMode;
  secondOfShippingLabelGeneration: number;
  weekTimeOfShippingLabelGeneration?: TimeOfWeek;
  upcomingShow?: UpcomingShow;
  upcomingShowId?: string;
  liveStream?: LiveStream;
  liveStreamId?: string;
  lastLiveStreamDate?: AppDate;
  evergreenVideo?: {
    videoURL: string;
    previewImageURL: string;
    size: {
      width: number;
      height: number;
    };
  };
  badges?: string[];
  shortDescription?: string;
  /** @deprecated since 09/25/24, use shippingMode instead */
  pickUpEnabled?: boolean;
  shippingMode?: ShippingMode[];
  showCustomization?: ShowCustomization;
  defaultCoverImage?: string;
  referralLink?: string;
  sharingUrl?: string;
  gmvT7d?: number;
  agencyId?: string;
  defaultProductCategoryIds?: string[];
  socialAccounts?: SocialAccount;
  tippingSettings?: PopStoreCreatorTippingSettings;
  avatarMeSettings?: {
    enabled?: boolean;
    enabledLipSync?: boolean;
    studioIntroSeen?: boolean;
    isStudioBannerClosed?: boolean;
    isEnabledAvatarMeForUserOnce?: boolean;
  };
  contactCard?: {
    firstName?: string;
    lastName?: string;
    nickName?: string;
    email?: string;
    phone?: string;
    hidden?: boolean;
    phoneHiddenFromUsers?: boolean;
    websiteUrl1?: string;
    websiteUrl2?: string;
    companyName?: string;
    address?: string;
  };
  quickLinks?: string[];
  bioSettings?: {
    hideGetYoursBanner?: boolean;
    collectionLayout?: CollectionLayoutType;
  };
  dmMinimumSubscriptionLevel?: PopStoreExtendedSubscriptionLevel;
  externalProductCtaText?: string;
  standaloneLeadsSettings?: {
    showOnPopStore?: boolean;
    title?: string;
    subTitle?: string;
    name?: { visible?: boolean; required?: boolean };
    email?: { visible?: boolean; required?: boolean };
    phone?: { visible?: boolean; required?: boolean };
  };
}

export enum TippingGoalStatus {
  ACTIVE = 'active',
  ACHIEVED = 'achieved',
  ENDED = 'ended',
  CANCELED = 'canceled',
}

// stores/{sellerId}/tippingGoals/{autoId}
export interface TippingGoal extends ModelBase {
  name: string;
  slug: string;
  description?: string;
  buttonText: string;
  minimumTipAmount: number;
  targetAmount: number;
  achievedAmount: number;
  status: TippingGoalStatus;
  dueAt: AppDate;
  achievedAt?: AppDate;
  endedAt?: AppDate;
  canceledAt?: AppDate;
  // total times of tipping received for this goal
  tippingCount: number;
}
